<script setup lang="ts">
  import { IconRadio, NumberStepperInput } from '@/shared/ui';
  import type { OpenTrainingCertificateType } from '../../model/useOpenTrainingForm';

  defineProps<{
    certificateRequired: boolean | null;
    certificateType: OpenTrainingCertificateType | null;
    workloadHours: number;
    enabled: boolean;
  }>();

  const emit = defineEmits<{
    'update:certificateRequired': [value: boolean];
    'update:certificateType': [value: OpenTrainingCertificateType];
    'update:workloadHours': [value: number | null];
  }>();
</script>

<template>
  <div class="flex flex-col items-start gap-3 border-b border-gray-02 px-6 py-8">
    <span
      id="open-training-certificate-required-label"
      class="text-sm font-semibold text-gray-07"
    >Necessário certificado?</span>
    <div
      class="flex gap-8"
      aria-labelledby="open-training-certificate-required-label"
    >
      <IconRadio
        data-testid="open-training-certificate-required-yes"
        :model-value="certificateRequired === null ? undefined : String(certificateRequired)"
        value="true"
        label="Sim"
        name="open-training-certificate-required"
        @update:model-value="emit('update:certificateRequired', true)"
      />
      <IconRadio
        data-testid="open-training-certificate-required-no"
        :model-value="certificateRequired === null ? undefined : String(certificateRequired)"
        value="false"
        label="Não"
        name="open-training-certificate-required"
        @update:model-value="emit('update:certificateRequired', false)"
      />
    </div>
  </div>

  <div
    v-if="enabled"
    class="flex flex-col items-start gap-3 border-b border-gray-02 px-6 py-8"
  >
    <span
      id="open-training-certificate-type-label"
      class="text-sm font-semibold text-gray-07"
    >Tipo de certificado:</span>
    <div
      class="flex gap-8"
      aria-labelledby="open-training-certificate-type-label"
    >
      <IconRadio
        data-testid="open-training-certificate-type-automatic"
        :model-value="certificateType ?? undefined"
        value="Automático"
        label="Automático"
        name="open-training-certificate-type"
        @update:model-value="emit('update:certificateType', 'Automático')"
      />
      <IconRadio
        data-testid="open-training-certificate-type-external"
        :model-value="certificateType ?? undefined"
        value="Externo"
        label="Externo"
        name="open-training-certificate-type"
        @update:model-value="emit('update:certificateType', 'Externo')"
      />
    </div>
  </div>

  <div class="flex flex-col items-start gap-1.5 border-b border-gray-02 px-6 py-8">
    <span
      id="open-training-workload-hours-label"
      class="text-sm font-semibold text-gray-07"
    >Carga horária: <span class="text-red-16">*</span></span>
    <div class="flex items-center gap-4">
      <NumberStepperInput
        data-testid="open-training-workload-hours"
        :model-value="workloadHours"
        :min="0"
        aria-labelledby="open-training-workload-hours-label"
        @update:model-value="emit('update:workloadHours', $event ?? 0)"
      />
      <span class="text-sm text-gray-03">horas</span>
    </div>
  </div>
</template>
